
    var video = '';
    var video_src = '';
    var exit_btn = '';
    var video_wrapper ='';
    var video_module ='';

    function exitFullscreenEsc() {
        if (!document.fullscreenElement && !document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement ) {
            video.classList.remove('play');
            video_module.classList.remove('hide');
            $('.exit-fullScreen').removeClass('active');
            video.firstElementChild.src=video_src;
            $('#Body').removeClass('overflow-hidden');
            video_wrapper.scrollIntoView();
        }
    }
    function exitFullscreenBtn(){
        if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.webkitCancelFullScreen) { /* Safari */
            document.webkitCancelFullScreen();
          } else if (document.msExitFullscreen) { /* IE11 */
            document.msExitFullscreen();
          }
        video.classList.remove('play');
        video_module.classList.remove('hide');
        $('.exit-fullScreen').removeClass('active');
        video.firstElementChild.src=video_src;
        $('#Body').removeClass('overflow-hidden');
        video_wrapper.scrollIntoView();
    }
    function videoInFullScreen(event) {
        video_module=event.currentTarget.parentElement.parentElement;
        video_wrapper = event.currentTarget.parentElement.parentElement.firstElementChild;
        video = event.currentTarget.parentElement.parentElement.firstElementChild.firstElementChild.nextElementSibling;
        video_src = video.firstElementChild.src;
        video.firstElementChild.src += '&autoplay=1';
        video.classList.add('play');
        exit_btn = video.firstElementChild.nextElementSibling;
        exit_btn.classList.add('active');
        $('#Body').addClass('overflow-hidden');
        video_module.classList.add('hide');
        if (video.requestFullscreen) {
            video.requestFullscreen();
          } else if (video.webkitRequestFullscreen) { /* Safari */
            video.webkitRequestFullscreen();
          } else if (video.msRequestFullscreen) { /* IE11 */
            video.msRequestFullscreen();
          }
        //scroll to top of video
        video.scrollIntoView();
    }
$(document).ready(function() {
    $('.play-btn ').click(videoInFullScreen);
    $(document).on('fullscreenchange', exitFullscreenEsc);
    $(document).on('webkitfullscreenchange', exitFullscreenEsc);
    $('.exit-fullScreen').on('click', exitFullscreenBtn);
});
define("videoModule", function(){});

